import React from "react";
import { Circle } from "@resources";
import PropTypes from 'prop-types';

const Steps = ({ steps, type = `numbers`, className = `info` }) => {

    const intToChar = (int) => {
        const code = `A`.charCodeAt(0);
        return String.fromCharCode(code + int);
    };

    const renderSteps = steps.map((s, index) => {

        const { title, description, icon = null } = s;

        const text = type === `numbers` ? index + 1 : intToChar(index);

        const element = icon === null ? <Circle text={text} /> : icon;

        return (<React.Fragment key={index}>

            <div className="flex flex-row items-center gap-x-4 w-full">
                <div className="self-start">
                    {element}
                </div>
                <div className="flex flex-col gap-y-1">
                    {
                        title &&
                        <h1 className="font-bold text-2xl">{title}</h1>
                    }
                    <description className="text-xl">{description}</description>
                </div>
            </div>
            {
                index < steps.length - 1 &&
                <divider className="w-full border-t-2 border-gray-300"></divider>
            }
        </React.Fragment>);
    });

    return (
        <div className={className}>
            {renderSteps}
        </div >
    );
};

Steps.propTypes = {
    steps: PropTypes.array.isRequired,
    type: PropTypes.oneOf([`numbers`, `letters`]),
    className: PropTypes.string
};



export default Steps;